import profile from './profile/profileSlices';
import auth from './auth/authSlices';
import property from './property/propertySlices';
import sidebar from './sidebar/sidebarSlices';

const rootReducer = {
  profile,
  auth,
  property,
  sidebar
};

export default rootReducer;
